/** CSS VENDORS **/
import '../vendor/photoswipe.css';
import '../vendor/custom-foundation.css';

/** CSS NATURACOLDPRESS **/
import "../css/_animations.scss";
import "../css/ladda.scss";
import "../css/common.scss";
import "../css/footer.scss";
import "../css/owl.scss";
import "../css/desktop-only.scss";
import "../css/mobile.scss";
import "../css/abonament.scss";



/** VENDORS **/
//require('photoswipe');
import '../vendor/photoswipe-ui-default.min';
import '../vendor/OwlCarousel2/owl.carousel.min';
// import 'modernizr';

/** SCRIPTS **/
import './utils';
// import './collapse';
import './pswp-utils.js';
import './wc_quantity.js';
import './local-cart.js';
import './diet.js';
import './dialog.js';
import './common.js';


import "./parallax";
import Nav from "./nav";
import ouibounce from "ouibounce";
import "./juice-popup";
import './handle-product-url';
import Dialog from "./dialog";
import Cookies from "./cookies";
import Utils from "./utils";

Nav.init();


$(document).on('ready', function () {
    $('.show_more').click(function () {
        const $el=$(this);
        $el.closest('.diet__description').find('.bundle__description__header_more').slideToggle();
        $el.toggleClass('open');
        return false;
    });

    //add arrows to yellow section
    if($(window).width() > breakpoints.medium) {
        $('.icon_text_wrap').after('<div class="icon_text_wrap icon-arrow-wrap"><div class="icon_text"><div class="icon_text__img_wrap"><img class="icon-arrow" src="/wordpress/wp-content/themes/ncp/assets/images/ikonki/arrow.png" alt="arrow"/></div></div></div>')
    }

    //cancel movie on home page
    $('.home').find('#movie').css('display', 'none');


    if ($(window).width() < breakpoints.medium) {
        /** mobile **/
        let $el = $('.przerywnik_extra .description');
        $el.addClass('owl-carousel');
        $el.owlCarousel({
            center: true,
            items: 1,
            loop: true,
            margin: 10,
            nav: true,
            navText: [' ', ' ']
        });
    } else {
        // desktop

        const newsletterEl = document.getElementById('newsletter-modal');

        var cookie_name = 'newslestter_active',
            fire = Cookies.read(cookie_name);
        if (fire == null) {
            Cookies.create(cookie_name, '0', 110);
        } else {
            var times = parseInt(fire) + 1;
            Cookies.create(cookie_name, (times < 4 ? times : 'never'), 110);
        }

        function openNewsletter() {
            console.log('Dialog fired!');
            if (!newsletterEl) {
                return;
            }
            new Dialog(newsletterEl);
            const form = newsletterEl.querySelector('form');

            form.addEventListener('submit', function (e) {
                e.preventDefault();
                var email_address = form.querySelector('input[type=email]').value;
                $(document).trigger({type: 'signup', mail: [email_address]});

                Utils.putSpinnerOn($(".send"));
                $.ajax({
                    url: woocommerce_params.ajax_url,
                    type: 'post',
                    data: {
                        action: 'newsletter_discount',
                        email: email_address
                    },
                    success: function (response) {

                        let json = JSON.parse(response);

                        if (window.dataLayer) {
                            window.dataLayer.push({
                                'event': 'form_submitted',
                                'form_name': 'newsletter',
                            });
                        }

                        if(json.status=="ok"){
                            Utils.disableSpinner();
                            window.location.replace('https://naturacoldpress.us13.list-manage.com/subscribe/confirm?u=ed8fee390916d611989af5523&id=ba595d641a&e=c577cc7a45');
                            setTimeout(function () {

                                $(newsletterEl).remove();

                            },6000);
                        }else{
                            Utils.disableSpinner();
                            window.location.replace('http://eepurl.com/bY7fZ5');
                        }

                    }
                });
            });
        }

        if (fire != 'never') {
            ouibounce(false, {
                aggressive: true, callback: openNewsletter
            });
        }
        $('.parallax-item').each(function (el) {
            let img = new Image(), parallax_img = $(this).find('img');
            img.onload = function () {
                parallax_img
                    .attr('src', parallax_img.data('src'))
                    .delay(el * 50).fadeIn(300);
            };
            img.src = parallax_img.data('src');

        }).promise().done(function () {
            const scene = document.getElementById('parallax-scene');
            if (scene) {
                new Parallax(scene, {
                    calibrateX: true,
                    calibrateY: true,
                    invertX: false,
                    invertY: false,
                    limitX: false,
                    limitY: false,
                    scalarX: 6,
                    scalarY: 9,
                    frictionX: 0.1,
                    frictionY: 0.1,
                    originX: 0.5,
                    originY: 0.5
                });
            }
        });
    }

    $(document).on( 'cf.submission', function (event, data ) {
        if (!data || !data.data || !data.data.status || !window.dataLayer) {
            return;
        }

        if (data.data.status !== 'complete') {
            return;
        }

        let formName = null;

        switch (data.data.form_name) {
            case 'Natura dla trenerów':
                formName = 'natura-dla-trenerow';
                break;
            case 'Natura dla firma':
                formName = 'natura-dla-firm';
                break;
        }

        if (!formName) {
            return;
        }

        window.dataLayer.push({
            'event': 'form_submitted',
            'form_name': formName,
        });
    });
});




// WEBPACK FOOTER //
// ./assets/js/main.js